import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgxImageCompressService } from 'ngx-image-compress';
import { Observable } from 'rxjs';
import { error } from 'jquery';
import { DashboardComponent } from '../control/dashboard/dashboard.component';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

interface DeferredPromise<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
}

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  @ViewChild(DashboardComponent)
  dashboard: DashboardComponent;
  private baseUrl: any = environment.baseUrl;
  private baseUrlStorage: any = environment.baseUrlStorage;
  // private baseUrl: any = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private imageCompress: NgxImageCompressService
  ) { }

  public storeUrl(type, url) {
    const data = { url: url };

    return this.http.post(`${this.baseUrl}` + `/s/download/` + type, data);
  }

  public storeFile(type, file, deviceSerial: any, options) {
    // let resolver = Promise.defer()
    // let input = options.filter ? files.filter(options.filter) : files
    // let input =


    const formData = new FormData()
    formData.append('file', file);
    const url = this.baseUrl + '/s/upload/' + type


    // fetch(url,{
    //   method :'POST',
    //   body :formData,
    //   mode:"cors"

    // })

    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        body: formData,
        mode: "cors"

      })
        .then((response: any) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}, Message: ${response.statusText}`);
          } else {
            resolve(response);
          }

        })
        .catch((error) => {
          console.error('Error uploading file:', error);
          reject(error);
        });
    });
    // if (input.length) {
    //   // .then(
    //   //   function (value) {
    //   //     resolver.resolve(value)
    //   //   }
    //   //   , function (err) {
    //   //     resolver.reject(err)
    //   //   }
    //   //   , function (progressEvent) {
    //   //     resolver.progress(progressEvent)
    //   //   }
    //   // )
    // }
    // else {
    //   let err = new Error('No input files')
    //   alert(err);
    //   resolver.reject(err)
    // }
  }

  //new
  // public uploadFile(file: File, serial: string, providerUrl: string, email: string) {
  //   // let resolver = Promise.defer();
  //   let resolver = this.createDeferred<any>();
  //   let url = providerUrl + '/pushFileToAndroid/' + email + '/' + serial;
  //   let formData = new FormData();
  //   // Append the file
  //   formData.append('file', file, file.name);
  //   fetch(url, {
  //     method: 'POST',
  //     body: formData,
  //     mode: "cors"
  //   }).then((response: any) => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}, Message: ${response.statusText}`);
  //       } else {
  //         // alert("Succesfully Uploaded to: /storage/emulated/0/Download/");
  //       }
  //     })
  //   return resolver.promise;
  // }

  public uploadFile(file: File, serial: string, providerUrl: string, email: string): Promise<any> {
    const resolver = this.createDeferred<any>();
    const url = providerUrl + '/pushFileToAndroid/' + email + '/' + serial;
    const formData = new FormData();

    // Append the file
    formData.append('file', file, file.name);

    fetch(url, {
      method: 'POST',
      body: formData,
      mode: "cors"
    })
      .then((response: any) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}, Message: ${response.statusText}`);
        } else {
          // Resolve the promise on success
          resolver.resolve(response);
        }
      })
      .catch((error) => {
        // Reject the promise on error
        resolver.reject(error);
      });

    return resolver.promise;
  }

  // public uploadFile(files, serial,providerUrl,email) {
  //   let resolver = Promise.defer();
  //   //let input = options.filter ? files.filter(options.filter) : files
  //   // let file : File = files[0];
  //   // let url = providerUrl+'/pushFileToAndroid/'+email+'/'+serial;
  //   let url = `${this.baseUrl}`+'/s/fileUploadAndroid/'+serial;

  //   // let fd = new FormData();
  //   // fd.append('files', files /*, optional filename */)

  //   this.http.post(url, files).subscribe((response:any) => {
  //     if(response){
  //       alert(response.data.message + "\n/storage/emulated/0/Download");
  //     }
  //   });
  //   return resolver.promise
  // }


  // Helper function to create a deferred promise
  private createDeferred<T>(): DeferredPromise<T> {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: any) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return {
      promise,
      resolve: resolve!,
      reject: reject!
    };
  }

  public saveScreenShot(screenshots: any, emailId: string): Observable<any> {
    const resolver = this.createDeferred<any>();
    let galleryData = new FormData();
    let screenshotsblob;

    fetch(`${this.baseUrl}` + screenshots.body.href)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        screenshotsblob = blob;
        galleryData.append('image', screenshotsblob);

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'multipart/form-data'
          })
        };

        // Create FormData
        let formData: FormData = new FormData();
        formData.append('bucket', 'ProteanStorageImage');
        formData.append('filePath', emailId + '/' + Date.now().toString() + '.png');
        formData.append('file', blob, 'captured-image.png');

        return fetch(this.baseUrlStorage + '/file/upload', {
          method: 'POST',
          body: formData,
          mode: "cors"
        });
      })
      .then(response => {
        resolver.resolve(response);
      })
      .catch(error => {
        resolver.reject(error);
      });

    // Convert Promise to Observable
    return from(resolver.promise);
  }
  getUploadedFiles(email: string, providerUrl: string): Observable<any[]> {
    const url = `${providerUrl}/showFiles/${email}`;
    return this.http.get<any[]>(url);
  }
  deleteFileFromServer(filename: string, email: string, providerUrl: string): Observable<any> {
    const url = `${providerUrl}/deleteFile/${email}/${filename}`;
    return this.http.delete<any>(url);
  }
  public fileUploadToServer(files: any, email: string, bridgeHost: string): Observable<any> {
    const resolver = this.createDeferred<any>();

    let formData = new FormData();
    formData.append('file', files, files.name);
    let url = bridgeHost + '/fileUpload/' + email;

    fetch(url, {
      method: 'POST',
      body: formData,
      mode: "cors"
    })
      .then((response: Response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}, Message: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data: any) => {
        // alert(data.message);
        resolver.resolve(data);
      })
      .catch((err: any) => {
        // alert(`Error: ${err.message}`);
        resolver.reject(err);
      });

    // Convert Promise to Observable
    return from(resolver.promise);
  }

  // public saveScreenShot(screenshots, emailId): Observable<any> {
  //   let resolver = Promise.defer()


  //   let galleryData = new FormData()
  //   let screenshotsblob;

  //   // screenshots.body.href
  //   // /s/image/44d44099-5dc9-4397-b87f-570f8ed24909/b7513e985ac4c726e720a570675ab18c
  //   // old
  //   fetch(`${this.baseUrl}` + screenshots.body.href)
  //     .then((response) => {
  //       let blob = response.blob()
  //       screenshotsblob = blob;
  //       galleryData.append('image', screenshotsblob)
  //       return blob;
  //     })
  //     .then((blob) => {
  //       const httpOptions = {
  //         headers: new HttpHeaders({
  //           'Content-Type': 'multipart/form-data'
  //         })
  //       };
  //       // Create FormData
  //       let formData: FormData = new FormData();
  //       formData.append('bucket', 'ProteanStorageImage');
  //       formData.append('filePath', emailId + '/' + Date.now().toString() + '.png');
  //       formData.append('file', blob, 'captured-image.png');
  //       // // const formData: FormData = new FormData();
  //       // // formData.append('file', blob);

  //       // body.append(blob.toString())
  //       //old
  //       // this.http.post(`${this.baseUrl}` + '/s/saveScreenShot/' + emailId, formData ).subscribe((response) => {
  //       // });
  //       //old
  //       //new
  //       fetch(this.baseUrlStorage + '/file/upload', {
  //         method: 'POST',
  //         body: formData,
  //         mode: "cors"
  //       })

  //       //new

  //     });
  //   //tulya
  //   //  this.http.get(`${this.baseUrl}`+screenshots.body.href,{withCredentials:true})
  //   return resolver.promise
  // }

  // public fileUploadToServer(files, email, bridgeHost) {
  //   let resolver = Promise // Promise.defer() was here



  //   // this.http.post(bridgeHost + '/fileUpload/' + email, files[0])
  //   // .subscribe((res)=>{
  //   //   alert(res.message);
  //   // })
  //   let formData = new FormData();
  //   formData.append('file', files, files.name);
  //   let url = bridgeHost + '/fileUpload/' + email;

  //   fetch(url, {
  //     method: 'POST',
  //     body: formData,
  //     mode: "cors"
  //   })
  //     .then((response: any) => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}, Message: ${response.statusText}`);
  //       }
  //       return response.json();
  //     })
  //     .then((data: any) => {
  //       alert(data.message);
  //     })
  //     .catch((err: any) => {
  //       alert(`Error: ${err.message}`);
  //     });
  //   return resolver.promise;
  // }

  public getScreenShot(emailId) {
    
    return from(fetch(this.baseUrlStorage + `file/fileLists?bucket=ProteanStorageImage`, {
      method: 'GET',
      mode: "cors"
    })).pipe(
      switchMap(response => from(response.json()))
    );
  }

  public deleteScreenShots(emailId) {
    let formdata: any = {
      "bucket": "ProteanStorageImage",
      "folderPrefix": emailId
    };
    return from(fetch(this.baseUrlStorage + '/file/deleteCommonFile', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formdata),
      mode: "cors"
    })).pipe(
      switchMap(response => from(response.json()))
    );
  }

  public deleteScreenShot(email: any, ssName: any) {
    // return this.http.delete(`${this.baseUrl}` + `/file/removeFile`);
    let formdata: any = {
      "bucket": "ProteanStorageImage",
      "filePath": ssName
    };

    return from(fetch(this.baseUrlStorage + '/file/removeFile', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formdata),
      mode: "cors"
    }));
  }
}

